import { useMutation, useQueryClient } from "@tanstack/react-query"

import { supabase } from "@/lib/supabase"

export type UpdateUserData = {
  userId: string
  fullName?: string
  role?: string
  team?: string
  sub_teams?: string[]
  dsp_id?: string
}

export const useUpdateUser = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (userData: UpdateUserData) => {
      const { data, error } = await supabase.functions.invoke("update-user", {
        body: userData,
      })

      if (error) {
        throw new Error(error.message)
      }

      return data
    },
    onSuccess: () => {
      // Invalidate and refetch the users query to update the UI
      queryClient.invalidateQueries({ queryKey: ["users"] })
    },
  })
}
